import { createAction } from "typesafe-actions";
export var set = createAction("backendAddress/SET", function (resolve) {
  return function (address) {
    return resolve(address);
  };
});
export var clear = createAction("backendAddress/CLEAR");